module.exports = __webpack_public_path__ + "img/001-copy@3x.22ad18e7.png";